<template>
  <div class="feed">
    <div class="container">
      <Navbar />
      <Buzon />
      <Footer />
    </div>
    <Notification />
  </div>
</template>


<script>
import Navbar from '@/components/Navigation';
import Buzon from '@/components/Buzon';
import Footer from '@/components/FooterInside';
import Notification from '@/components/Notification';

export default {
  name: 'feed',
  components: {
    Navbar,
    Buzon,
    Footer,
    Notification
  },
  data(){
    return{
      login: 2
    }
  },
  created(){
    if(localStorage.token){
      this.$parse.User.become(localStorage.token)
      .then((res) => {
        if (res.id == '') {
          this.$router.push('/')
        }
      })
      .catch((error) => {
        this.logOut()
      });

    } else {
      this.$router.push('/')
    }
  },
  beforeMount() {
    localStorage.login = this.login;
  },
  methods: {
    logOut(){
      localStorage.objectId = ''
      localStorage.token = ''
      const user = this.$parse.User.logOut()
      if (user) {
        this.$router.push('/')
      }
    }
  }
}
</script>
